import { useMemo } from 'react';
import { WebUrl } from '@web/url';
import { isEmpty } from 'lodash';

function useImageParams(options) {
  const {
    src,
    baseUrl,
    baseResolutionHeight,
    baseResolutionWidth,
    imageType
  } = options;
  const useMemoHandler = useMemo(() => {
    if (src) {
      const srcUrl = new WebUrl(src);
      const queryParams = srcUrl.getQuery();

      if (!isEmpty(queryParams)) {
        const imageSrc = src.includes('?') ? `${srcUrl.origin}${srcUrl.pathname}` : src;
        return {
          imageSrc,
          imageUrl: imageSrc,
          imageHeight: queryParams.hei || baseResolutionHeight,
          imageWidth: queryParams.wid || baseResolutionWidth,
          imageOfType: queryParams.fmt || imageType
        };
      }
    }

    const imageSrc = src !== null && src !== void 0 ? src : '';
    const imageUrl = imageSrc.includes('http') ? imageSrc : `${baseUrl}${imageSrc}`;
    return {
      imageUrl,
      imageSrc,
      imageHeight: baseResolutionHeight,
      imageWidth: baseResolutionWidth,
      imageOfType: imageType
    };
  }, [baseResolutionHeight, baseResolutionWidth, baseUrl, imageType, src]);
  return useMemoHandler;
}

export { useImageParams };
